import { render, staticRenderFns } from "./CScrollPro.vue?vue&type=template&id=cc164a56&scoped=true"
import script from "./CScrollPro.vue?vue&type=script&lang=js"
export * from "./CScrollPro.vue?vue&type=script&lang=js"
import style0 from "./CScrollPro.vue?vue&type=style&index=0&id=cc164a56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc164a56",
  null
  
)

export default component.exports